module.exports = __webpack_public_path__ + "img/event-hero.401978a8.png";